// getTrainingLibraryList

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getTrainingLibraryList,
    addTrainingLibrary,
    updateTrainingLibrary,
    updateTrainingLibraryStatus,
} from "../../Api/AdminApiCall";

export const fetchTrainingLibraryList = createAsyncThunk(
    "admin/fetchTrainingLibraryList",
    async (params, { rejectWithValue }) => {
        try {
            const res = await getTrainingLibraryList(params);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load Trainig library"
            );
        }
    }
);

export const addTrainingLibraryApi = createAsyncThunk(
    "admin/addTrainingLibraryApi",
    async (data, { rejectWithValue }) => {
        try {
            const res = await addTrainingLibrary(data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to add training library"
            );
        }
    }
);

export const updateTrainingLibraryApi = createAsyncThunk(
    "admin/updateTrainingLibraryApi",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await updateTrainingLibrary(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to update training library"
            );
        }
    }
);

export const toggleTrainingLibraryStatus = createAsyncThunk(
    "admin/toggleTrainingLibraryStatus",
    async ({ id, isActive, userId }, { rejectWithValue }) => {
        try {
            const res = await updateTrainingLibraryStatus(id, isActive, userId);
            return { id, isActive, data: res.data };
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to toggle training library status"
            );
        }
    }
);

const trainingLibrarySlice = createSlice({
    name: "trainingLibrarySlice",
    initialState: {
        // Will hold the full API response object, e.g. { data: { items: [...] }, ... }
        trainingLibraryList: null,
        addTrainingLibrary: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch list
            .addCase(fetchTrainingLibraryList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTrainingLibraryList.fulfilled, (state, action) => {
                state.loading = false;
                state.trainingLibraryList = action.payload;
            })
            .addCase(fetchTrainingLibraryList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Add item
            .addCase(addTrainingLibraryApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addTrainingLibraryApi.fulfilled, (state, action) => {
                state.loading = false;

                // Safely append the newly created item into the existing items array
                const list = state.trainingLibraryList;
                const items = list?.data?.items;

                if (Array.isArray(items)) {
                    const newItem = action.payload?.data || action.payload;
                    items.push(newItem);
                }
            })
            .addCase(addTrainingLibraryApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update item
            .addCase(updateTrainingLibraryApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateTrainingLibraryApi.fulfilled, (state, action) => {
                state.loading = false;

                const list = state.trainingLibraryList;
                const items = list?.data?.items;

                if (Array.isArray(items)) {
                    const updated = action.payload?.data || action.payload;
                    const updatedId = updated?.id ?? action.meta?.arg?.id;

                    if (updatedId !== undefined && updatedId !== null) {
                        const index = items.findIndex(
                            (item) => item.id === updatedId
                        );
                        if (index !== -1) {
                            items[index] = {
                                ...items[index],
                                ...updated,
                            };
                        }
                    }
                }
            })
            .addCase(updateTrainingLibraryApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Toggle status
            .addCase(toggleTrainingLibraryStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(toggleTrainingLibraryStatus.fulfilled, (state, action) => {
                state.loading = false;

                const list = state.trainingLibraryList;
                const items = list?.data?.items;

                if (Array.isArray(items)) {
                    const { id, isActive } = action.payload;
                    const index = items.findIndex((item) => item.id === id);
                    if (index !== -1) {
                        items[index] = {
                            ...items[index],
                            is_active: isActive,
                        };
                    }
                }
            })
            .addCase(toggleTrainingLibraryStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

const trainingLibrarySliceReducer = trainingLibrarySlice.reducer;

export default trainingLibrarySliceReducer;
